// PaymentsListMobile.tsx
import { IonList, IonItem, IonLabel, IonNote } from "@ionic/react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import { usePaymentsStore } from "../../store/payments";
import { Settings, Payment } from "../../interfaces";
import { IconArrowBack, IconCheck, IconX } from "@tabler/icons-react";

interface Props {
  settings: Settings;
  handleClick: (payment: Payment) => void;
}

const PaymentsListMobile: React.FC<Props> = ({ settings, handleClick }) => {
  const payments = usePaymentsStore((state) => state.payments);
  if (!payments.length) {
    return (
      <IonList lines="none">
        <IonItem>
          <IonLabel className="ion-text-center w-100">
            <FormattedMessage id="common.noResults" />
          </IonLabel>
        </IonItem>
      </IonList>
    );
  }

  return (
    <IonList inset={false}>
      {payments.map((p) => {
        const contact = p.contact;
        const itemReferenceBase = p.itemName
          ? `${p.itemQuantity || 1} x ${p.itemName}`
          : "";
        const referenceValue = (p.bookings || []).length
          ? (p.bookings || []).map((b: any) => b.externalId).join(", ")
          : itemReferenceBase
            ? p.itemReferenceHint
              ? `${itemReferenceBase} • ${p.itemReferenceHint}`
              : itemReferenceBase
            : "";
        /* Badge para el estado del pago */
        const paymentBadge = (
          <div
            className={classNames("badge ", {
              "text-bg-light": ["expired", "active"].includes(p.paymentStatus),
              "text-bg-success": p.paymentStatus === "paid",
              "text-bg-warning": p.refundStatus === "refunded",
            })}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {p.refundStatus === "refunded" ? (
                <IconArrowBack size={18}></IconArrowBack>
              ) : p.paymentStatus === "paid" ? (
                <IconCheck size={18}></IconCheck>
              ) : (
                <IconX size={18}></IconX>
              )}
            </div>
          </div>
        );

        return (
          <IonItem key={p.id} onClick={() => handleClick(p)}>
            <div slot="start">{paymentBadge}</div>
            <IonLabel>
              <div className="fs-3 d-flex align-items-center justify-content-between no-wrap-row">
                <b className="truncate-text">
                  {contact.name || contact.phoneNumber}
                </b>
                <span>{p.amount}</span>
              </div>

              {settings.companies.length > 1 && (
                <div className="fs-2 color-step-700">{p.company}</div>
              )}
              {referenceValue && (
                <div className="fs-2 color-step-700 truncate-text">
                  {referenceValue}
                </div>
              )}

              <div className="d-flex align-items-center justify-content-between">
                <div className="fs-2 color-step-700">{p.date}</div>
              </div>
            </IonLabel>
          </IonItem>
        );
      })}
    </IonList>
  );
};

export default PaymentsListMobile;
